import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js'
import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js'
import TemplatesIndex from 'trunks/vue/admin/components/templates/templates_index.js'
import TemplateForm from 'trunks/vue/admin/components/templates/template_form.js'
import SettingsMenu from 'trunks/vue/admin/components/settings/settings_container/settings_menu.js'

function parsePayload(element, key) {
  if (!element) return {}
  return JSON.parse(element.dataset[key] || '{}')
}

class Admin__TemplatesController extends Skylark.App.BaseController {
  index() {
    this._generateSettingsSidebarView('settings__templates')
    const container = DomMaster.find('#js-templates-index').node
    if (!container) return

    new TemplatesIndex({
      el: container,
      propsData: {
        templatesData: parsePayload(container, 'templates')
      }
    })
  }

  new() {
    this._generateSettingsSidebarView('settings__templates')
    this._generateTemplateForm('new')
  }

  show() {
    this._generateSettingsSidebarView('settings__templates')
    this._generateTemplateForm('edit')
  }

  get_menu() {
    this._generateSettingsSidebarView('settings__templates')
    const container = DomMaster.find('#js-template-menu').node
    if (!container) return

    new SettingsMenu({
      el: container,
      propsData: {
        activeTab: 'templates',
        menuData: parsePayload(container, 'menu')
      }
    })
  }

  _generateTemplateForm(mode) {
    const container = DomMaster.find('#js-template-form').node
    if (!container) return

    new TemplateForm({
      el: container,
      propsData: {
        mode: container.dataset.mode || mode,
        formData: parsePayload(container, 'template')
      }
    })
  }
}

Admin__TemplatesController.include(GenerateMorePopover, SettingsNavigator)

export default Admin__TemplatesController
